import { jsx as t } from "react/jsx-runtime";
import { clsx as n } from "../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.js";
import { Breakpoints as M, remCalc as a } from "../../style/base/index.js";
import { useBreakpointMatch as O } from "../../utils/use-breakpoint-match.js";
import { RocheUIIcon as i } from "../icon/roche-icon.js";
import o from "./roche-video-player.module.scss.js";
const k = 64, R = 80, U = 24, A = ({
  onPlay: p,
  onPause: l,
  fullscreen: m,
  isPlaying: e,
  videoloop: _,
  videoTitle: d,
  pauseLabel: h,
  playLabel: v
}) => {
  const y = O(M.MEDIUM), u = `${a(y ? k : R)}rem`, C = `${a(U)}rem`, I = n(o["video-player__overlay"], o["video-player__overlay-videoloop"]), b = n(
    o["video-player__overlay"],
    e && o["video-player__overlay--hidden"]
  ), f = _ ? I : b, E = e ? "pause" : "play", L = e ? h : v, s = (r) => {
    r.preventDefault(), e && l ? l() : p();
  }, N = (r, c) => c ? `${r} ${c}` : r;
  return e && m ? /* @__PURE__ */ t("button", { className: o["video-player__close-button"], onClick: s, type: "button", children: /* @__PURE__ */ t(i, { icon: "close", height: C }) }) : /* @__PURE__ */ t("div", { className: f, children: /* @__PURE__ */ t(
    "button",
    {
      onClick: s,
      className: o["video-player__overlay-icon"],
      "aria-label": N(L, d),
      type: "button",
      children: /* @__PURE__ */ t(i, { icon: E, height: u })
    }
  ) });
};
export {
  A as RocheUIVideoPlayerControls
};
